import type { TErrorBody } from '@cascade/api-client/errors';
import { isRecord } from '#utils/object/index.ts';

const SECOND = 1000;

export const retryAfterOf = (response: Response): number | undefined => {
  const header = response.headers.get('Retry-After');

  if (!header) {
    return undefined;
  }

  const seconds = Number(header);

  if (Number.isFinite(seconds)) {
    return Math.max(0, seconds * SECOND);
  }

  const at = Date.parse(header);

  return Number.isNaN(at) ? undefined : Math.max(0, at - Date.now());
};

export const isEnvelope = (data: unknown): data is { error: TErrorBody } =>
  isRecord(data) &&
  isRecord(data.error) &&
  'code' in data.error &&
  'message' in data.error;
